<template>
  <v-app>
    <v-content>
      <dark-template-container />
    </v-content>
  </v-app>
</template>

<script>
import DarkTemplateContainer from '@/views/dark-template/Container'

export default {
  name      : 'App',
  metaInfo: {
    title: 'Alexander Alvarez S. | Full Stack Developer | Ethical Hacker',
    meta: [
      { name: 'description', content: 'Full Stack Developer with expertise in MERN stack, Vue.js, Nuxt.js, and cloud technologies.' },
      { name: 'keywords', content: 'Full Stack Developer, Vue.js, Node.js, AWS' },
      // Open Graph tags
      { property: 'og:title', content: 'Full Stack Developer | Your Name' },
      { property: 'og:description', content: 'Full Stack Developer specializing in MERN stack, Vue.js, and cloud services.' },
      { property: 'og:image', content: 'https://desarrollador.info/img/avatar.jpg' }
    ]
  },
  components: { DarkTemplateContainer },
  data () {
    return {}
  },
}
</script>
